import { allTrackers } from "app/services/track/track";

import createHomePageTrackingService from "./factory";

const homePageTrackingService = createHomePageTrackingService(allTrackers.dispatchTrackEvent.bind(allTrackers));

export default homePageTrackingService;
